import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import customerReducer from "../app/pages/customer/customerSlice";
import productReducer from "../app/pages/product/productSlice";
import companyReducer from "../app/pages/company/companySlice";
import visitReducer from "../app/pages/visit/visitSlice";
import journeyReducer from "../app/pages/journey/journeySlice";
import pricelistReducer from "../app/pages/pricelist/pricelistSlice";
import uomReducer from "../app/pages/uom/uomSlice";
import settingJourneyReducer from "../app/pages/setting-journey/settingJourneySlice";
import initialloadReducer from "../app/pages/initialload/initialloadSlice";
import userReducer from "../app/pages/user/userSlice";
import orderReducer from "../app/pages/order/orderSlice";
import adjustmentStockReducer from "../app/pages/adjustment-stock/adjustmentStockSlice";
import menuReducer from "../app/pages/menu/menuSlice";
import roleReducer from "../app/pages/role/roleSlice";
import settingReducer from "../app/pages/setting/settingSlice";
import crashReportReducer from "../app/pages/crash-report/crashReportSlice";
import paramReducer from "../app/pages/param/paramSlice";
import licenseReducer from "../app/pages/license/licenseSlice";
import branchReducer from "../app/pages/branch/branchSlice";
import regulerDiscReducer from "../app/pages/reguler-disc/regulerDiscSlice";
import specialDiscReducer from "../app/pages/special-disc/specialDiscSlice";
import apilogReducer from "../app/pages/apilog/apilogSlice";
import areaReducer from "../app/pages/area/areaSlice";
import distributorReducer from "../app/pages/distributor/distributorSlice";
import sellInReducer from "../app/pages/sell-in/sellInSlice";
import surveyReducer from "../app/pages/survey/surveySlice";
import resultReducer from "../app/pages/result-survey/resultSlice";
import topReducer from "../app/pages/top/topSlice";
import accurateReducer from "../app/pages/accurate/accurateSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  customer: customerReducer,
  product: productReducer,
  company: companyReducer,
  visit: visitReducer,
  journey: journeyReducer,
  pricelist: pricelistReducer,
  uom: uomReducer,
  settingJourney: settingJourneyReducer,
  initialload: initialloadReducer,
  user: userReducer,
  order: orderReducer,
  adjustmentStock: adjustmentStockReducer,
  menu: menuReducer,
  role: roleReducer,
  setting: settingReducer,
  crashReport: crashReportReducer,
  param: paramReducer,
  license: licenseReducer,
  branch: branchReducer,
  regulerDisc: regulerDiscReducer,
  specialDisc: specialDiscReducer,
  apilog: apilogReducer,
  area: areaReducer,
  distributor: distributorReducer,
  sellIn: sellInReducer,
  survey: surveyReducer,
  result: resultReducer,
  top: topReducer,
  accurate: accurateReducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
